module.exports = __webpack_public_path__ + "static/media/rotaryAirlock.0f48940a.png";